import React from "react";
import {Link as RouterLink} from "react-router-dom";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import {AuthPageLayout} from "../../components/AuthShell";
import {
  BodyText,
  Heading,
  IconTile,
  PrimaryButton,
  StatePanel,
} from "../EmailVerification/styled";

/**
 * Landing page for Stripe's PUBLIC checkout success redirect
 * (STRIPE_PUBLIC_SUCCESS_URL). The buyer has no login yet: the backend webhook
 * creates the account and sends the account-claim email. Stripe query params
 * (flow, session_id) are intentionally ignored.
 */
export default function ThanksPage() {
  return (
    <AuthPageLayout testId="public-checkout-thanks">
      <StatePanel>
        <IconTile aria-hidden="true"><CheckCircleOutlineRoundedIcon sx={{fontSize: 26}} /></IconTile>
        <Heading component="h1">Payment received</Heading>
        <BodyText>
          Thanks for subscribing to AlphaSearch. We&apos;ve emailed you a link to create your password
          and set up your account — check your inbox (and spam folder).
        </BodyText>
        <BodyText>
          Look for the email titled &ldquo;Complete your Alphasearch account setup&rdquo;.
        </BodyText>
        <PrimaryButton component={RouterLink} to="/" variant="contained" fullWidth>
          Go to login
        </PrimaryButton>
      </StatePanel>
    </AuthPageLayout>
  );
}
